import { Spin } from 'antd';
import React from 'react';
import './SpinnerFallback.css';

const SpinnerFallback = () => (
  <div className="spinner-container">
    <Spin delay={500} size="large" />
  </div>
);

export default SpinnerFallback;
